module.exports = __webpack_public_path__ + "img/cases05-bg.09763ed4.jpg";